export enum ROUTES {
  LOGIN = "/",
  SIGNUP = "/invite",
  DASHBOARD = "/dashboard",
  SIDEBAR = "/sidebar",
  ADDEXPENSE = "/addExpense",
  FORGOT_PASSWORD = "/forgotPassword",
  BRANCHES = "/branches",
  CATEGORIES = "/categories",
  ADD_CATEGORY = "/addCategory",
  UPDATE_CATEGORY = "/updateCategory",
  ORGANIZATION_FORM = "/organizationForm",
  MEMBERS = "/members",
  ADD_TAG = "/addTag",
  UPDATE_TAG = "/updateTag",
  ITEMS = "/items",

  CREATE_PASSWORD = "/password-reset-confirm",
  ADD_BRANCH = "/addBranch",
  UPDATE_BRANCH = "/updateBranch",

  ADD_MEMBERS = "/addMembers",
  UPDATE_EXPENSE = "/updateExpense",
  PROFILE = "/profile",

  NOTFOUND = "*",
  EXPORT_PDF = "/exportPdf",
  INVITATIONS = "/invitations",
}
